import { adminInvitationsEndpoints, adminInvitationsQueryParams } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiInvitationHandler } from "@/services/shared";
import type {
    ApiInvitationType,
    ApiPaginatedResponseType,
    InvitationType,
    ListInvitationsFiltersType,
} from "@/types";

export const listInvitationsHandler = async (filters: ListInvitationsFiltersType = {}): Promise<InvitationType[]> => {
    const params: Record<string, string> = {};

    if (filters.status) params[adminInvitationsQueryParams.status] = filters.status;

    const response = await axiosClient.get<ApiPaginatedResponseType<ApiInvitationType> | ApiInvitationType[]>(
        adminInvitationsEndpoints.base,
        { params },
    );

    const list = Array.isArray(response.data) ? response.data : response.data.data;

    return list.map(transformApiInvitationHandler);
};
